import { ungzip } from 'pako';

type EntityType = 'AD_ACCOUNT' | 'CREATIVE_LIBRARY' | 'MARKETER_ORGANIZATION' | 'PUBLISHER_ORGANIZATION';

type DAAPIRolesV4 = {
  ['entity-id']: string;
  ['entity-type']: EntityType;
  role: {
    name: string;
    permissions: string[] | null;
  };
};

export type Token = {
  //decoded roles
  user_role_v4: string;
  sub: string;
};

export const checkIsAdminAllowedByToken = (decodedToken: Token): boolean | null => {
  try {
    const binaryString = atob(decodedToken!.user_role_v4);

    const charData = new Uint8Array(binaryString.length);

    for (let i = 0; i < binaryString.length; i++) {
      charData[i] = binaryString.charCodeAt(i);
    }

    const decompressed = ungzip(charData, { to: 'string' });

    const parsedRoles: DAAPIRolesV4[] = JSON.parse(decompressed);

    return parsedRoles.some(
      (parsedRole) => parsedRole['entity-type'] === 'PUBLISHER_ORGANIZATION' || parsedRole.role.name === 'SELLER'
    );
  } catch (error) {
    console.error(error);
    return null;
  }
};
